import React from 'react';
import ContactUsSection from '../components/ContactUs/ContactUsSection';
import Silk from '../components/SilkBackground';

export default function ContactUs() {
  return (
  <>
    <div className="fixed inset-0 -z-10 pointer-events-none">
        <Silk
          speed={10}
          scale={1}
          color="#e3c8b3"
          noiseIntensity={1.5}
          rotation={0}
        />
    </div>
  

    <div className='bg-[#f2d6c0]/80 backdrop-blur-md'>
        <ContactUsSection />
    </div>
  </>
  );
} 